import { getBrowserTimezone } from './timezoneData';

/** Shared defaults aligned with CreateScheduleDialog and legacy dataProtect cron default. */
export const DEFAULT_DAILY_HOUR = 6;
export const DEFAULT_DAILY_MINUTE = 0;
export const DEFAULT_CRON_EXPRESSION = '0 9-17/1 * * 1-5 *';
export const DEFAULT_REPEATING_FREQUENCY = 5;
export const DEFAULT_REPEATING_FREQUENCY_UNIT = 'minute' as const;

/** dataProtect uses UTC when daily schedule has no stored timezone. */
export const LEGACY_DAILY_TIMEZONE_FALLBACK = 'UTC';

export const MIN_REPEATING_MINUTE_FREQUENCY = 5;

export function getDefaultDailyTimeZone(): string {
  return getBrowserTimezone();
}

export function getDefaultCronTimeZone(): string {
  return getBrowserTimezone();
}

export function formatDefaultDailyTime(): string {
  return `${DEFAULT_DAILY_HOUR.toString().padStart(2, '0')}:${DEFAULT_DAILY_MINUTE.toString().padStart(2, '0')}`;
}

/** dataProtect recipe editor (trigger.js) defaults */
export const RECIPE_EDITOR_DAILY_HOUR = 0;
export const RECIPE_EDITOR_DAILY_MINUTE = 0;
export const RECIPE_EDITOR_DEFAULT_REPEATING_FREQUENCY = 1;
export const RECIPE_EDITOR_DEFAULT_REPEATING_FREQUENCY_UNIT = 'hour' as const;

export const REPEATING_INTERVAL_HELP =
  'Runs every N minutes or hours from the first execution time. For a fixed time each day, use Daily.';

export const REPEATING_LEGACY_TZ_HELP =
  'This schedule has no stored timezone. Times use your browser timezone. Select a timezone to enable DST-aware scheduling.';

export const ADVANCED_CRON_TZ_HELP =
  'Confirm your timezone before saving. Schedule times are entered in this timezone.';

export const ADVANCED_CRON_BOOTSTRAP_TZ_WARNING =
  "Timezone defaults to your browser setting. Confirm it matches this schedule's intended author timezone before saving — EventBridge deploy will use this timezone and convert the stored UTC cron to local wall clock.";

export const ADVANCED_CRON_MIGRATION_TZ_INFO =
  'This schedule has no stored timezone. Select your timezone and click Confirm timezone. Cron expression bytes will not change until you edit the schedule.';

export const ADVANCED_CRON_MIGRATION_TZ_CONFIRM_REQUIRED =
  "Confirm timezone before saving. Timezone defaults to your browser setting — verify it matches this schedule's intended author timezone. Cron expression bytes will not change until you edit the schedule.";

export const ADVANCED_CRON_MIGRATION_TF_INFO =
  'Review the time frame parsed from your stored UTC schedule. Compare Next 10 runs, adjust if needed, then click Confirm time frame.';

export const ADVANCED_CRON_MIGRATION_TF_CONFIRM_REQUIRED =
  'Confirm time frame before saving. Compare the parsed values below with Next 10 runs, adjust if needed, then click Confirm time frame.';

export const REPEATING_DST_RESAVE_HELP =
  'After daylight saving changes, verify the start time still looks correct and save if needed.';

export function formatRecipeEditorDailyTime(): string {
  return `${RECIPE_EDITOR_DAILY_HOUR.toString().padStart(2, '0')}:${RECIPE_EDITOR_DAILY_MINUTE.toString().padStart(2, '0')}`;
}

/** Recipe editor ScheduleDialog — legacy trigger.js defaults (midnight daily, 1 hour repeating). */
export function getRecipeEditorDailyDefaults(): {
  hour: number;
  minute: number;
  timeZone: string;
} {
  return {
    hour: RECIPE_EDITOR_DAILY_HOUR,
    minute: RECIPE_EDITOR_DAILY_MINUTE,
    timeZone: getDefaultDailyTimeZone(),
  };
}

export function getRecipeEditorRepeatingDefaults(): {
  frequency: number;
  frequencyUnit: 'minute' | 'hour';
  startingAt: { hour: number; minute: number } | null;
  timeZone: string;
} {
  return {
    frequency: RECIPE_EDITOR_DEFAULT_REPEATING_FREQUENCY,
    frequencyUnit: RECIPE_EDITOR_DEFAULT_REPEATING_FREQUENCY_UNIT,
    startingAt: null,
    timeZone: getDefaultDailyTimeZone(),
  };
}
